import { actions, bugReportByCode, bugReportStatuses, BugReportWithUser } from 'entities';
import { useLang } from 'hooks/lang';

import { Button } from 'components/Blocks';

import { cn, resolveColorClass } from 'styles';

interface BugReportStatusChangeProps {
  report: BugReportWithUser;
  updateReport: (data: Partial<BugReportWithUser>) => void;
}

export function RequestContextButton({ report, updateReport }: BugReportStatusChangeProps) {
  const { t } = useLang();

  const { status } = report;

  const changeStatus = actions.feedback.changeBugReportStatus.use({
    params: {
      comment: '',
      status: bugReportStatuses.needsContext.code,
      reportId: report.id,
    },

    onSuccess: () => updateReport({ status: bugReportStatuses.needsContext.code }),
  });

  const { statusTargets } = bugReportByCode[status];

  const canRequestContext = statusTargets.includes(bugReportStatuses.needsContext.code);

  if (!canRequestContext) return null;

  return (
    <Button
      variant="link"
      {...changeStatus.buttonProps}
      className={cn(
        resolveColorClass(bugReportStatuses.needsContext.color, 'text'),
        'ml-2 inline-flex w-fit',
      )}
    >
      {t('request-context')}
    </Button>
  );
}
